export const SV = {
  preparing_zip: "Förbereder zip…",
  compressing: "Komprimerar…",
  info_icon: "När den är markerad som slutförd kan inga ytterligare medlemmar gå med eller läggas till, och alla chattgrupper kommer att inaktiveras. Observera att projektet, tillsammans med alla chattgrupper och data, kommer att förbli tillgängligt i ett inaktiverat tillstånd.",
  mark_is_done: "Är du säker på att du vill markera projektet som slutfört? När det är markerat kan inga ytterligare medlemmar gå med eller läggas till, och alla chattgrupper kommer att inaktiveras. Observera att projektet, tillsammans med alla chattgrupper och data, kommer att förbli tillgängligt i ett inaktiverat tillstånd.",
  mark_not_done: "Är du säker på att du vill öppna projektet igen? När det är markerat som öppet kan ytterligare medlemmar gå med eller läggas till, och alla chattgrupper kommer att aktiveras igen.",
  mark_as_completed: "Markera projekt som slutfört",
  room_completed: "Projekt slutfört",
  room_members: "Projektets medlemmar",
  deactivated_rooms: "Inaktiverade projekt",
  deactivated_chats: "Inaktiverade chattar",
  completed_rooms: "Slutförda projekt",
  request_to_join_a_room: 'Begäran att gå med i projektet',
  wants_to_rejoin_room: 'Username vill gå med i projektet Roomname igen.',
  invited_you_to_join_room: 'Username har bjudit in dig att gå med i projektet Roomname.',
  restart: "Starta om",
  update_text: "En ny uppdatering är tillgänglig. Klicka på starta om för att installera uppdateringen.",
  update_availble: "Uppdatering tillgänglig",
  Loading: "Laddar...",
  logout: "Logga ut",
  back: 'Tillbaka',
  company_list: "Företagslista",
  followers: "Följare",
  followings: "Följer",
  article: "Artikel",
  companies: "Företag",
  one_to_one_chat: " En-mot-en chatt",
  profile: "Profil",
  company: "Företag",
  company_selection: "Företagsval",
  home: "Hem",
  contact: "Kontakt ",
  add_company: "Lägg till företag ",
  add_project: "Lägg till projekt ",
  capacities: "Kapaciteter ",
  work_area: "Arbetsområde",
  company_services: "Företagets tjänster",
  website: "Webbplats",
  search_contacts: "Sök kontakter",
  add_or_join_a_company: "Lägg till eller gå med i ett företag",
  follow: "Följ",
  following: "Följer",
  like: "Gilla",
  company_contacts: "Företagskontakt",
  leave_the_company: "Lämna företaget",
  news: "Nyheter",
  earlier: "Tidigare",
  action: "Åtgärd",
  another_action: "En annan åtgärd",
  something_else: "Något annat",
  search: "Sök",
  search_rooms: "Sök projekt",
  search_articles: "Sök artiklar",
  contacts: "Kontakter",
  suggestions: "Förslag",
  project_list: "Projektlista",
  search_results: "Sökresultat",
  add_or_join_project: "Lägg till eller gå med i projekt",
  details: "Detaljer",
  your_position_within_company:
    "Vänligen välj din position inom företaget.",
  close_modal: "Stäng",
  map: "Karta",
  or: "Eller",
  name: "Namn*",
  street: "Gata*",
  house_number: "Husnummer",
  postal_code: "Postnummer",
  city: "Stad*",
  opened_by: "Öppnad av:",
  project_No: "Projektnummer: ",
  building_type: "Byggnadstyp*",
  building_types: "Byggnadstyp",
  add_join: "Lägg till/Gå med",
  mandatory_fiels: "*obligatoriska fält",
  invalid_fiels: "Detta fält är obligatoriskt",
  add_or_join_company: "Lägg till eller gå med i företag",
  name_of_the_company: "Företagets namn",
  edit_company_details: "Redigera företagsdetaljer",
  branch_of_the_building_industry: "Gren av byggindustrin",
  corporate_form: "Företagsform",
  position_within_company: "Position inom företaget",
  request_confirmation: "Väntande projektförfrågningar",
  company_e_mail: "Företagets e-post",
  type_of_filter: "Skriv för att filtrera...",
  setting: "Inställning",
  dashboard: "Instrumentpanel",
  settings: "Inställningar",
  views: "Visningar",
  times_seen: "gånger sedd",
  see_more: "...mer",
  see_less: "...mindre",
  in_search: "i sökningen",
  reset_password: "Återställ lösenord",
  submit: "Skicka",
  password: "Lösenord",
  email: "E-post",
  confirm_password: "Bekräfta lösenord",
  reset_email: "Återställ e-post",
  update: "Uppdatera",
  new_email: "Ny e-post",
  kjuup_message: "Kjuup Meddelande",
  delete_profile: "Radera profil?",
  my_position: "Min position:",
  add: "lägg till",
  owner_company_admin: "Företagsadministratör :",
  owner_company_admin_new: "Företagsadministratör",
  mutual_contact: "gemensam kontakt",
  mutual_contacts: "gemensamma kontakter",
  co_owner: "Medägare",
  managing_director: "Verkställande direktör",
  associate: "Medarbetare",
  secretary: "Sekreterare",
  employee: "Anställd",
  project_manage: "Projektledare",
  auto_chat_translation: "Automatisk chattöversättning",
  translate_room_group_names: "Översätt chattgruppnamn",
  translate_room_group_names_info: "När det är aktiverat översätts chattgruppnamn automatiskt till ditt gränssnittsspråk.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "När aktiverat öppnas E-Post-fliken som standard istället för Meddelanden när du öppnar appen.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Språk",
  english: "Engelska",
  german: "Tyska",
  french: "Franska",
  italian: "Italienska",
  change_language: "Ändra språk",
  my_companies: "Mina företag",
  employees: "Anställda",
  invite_with_a: "Bjud in till Kjuup",
  add_member: "Lägg till medlem",
  add_user: "Lägg till användare",
  send_location: "Skicka plats",
  assign_admin_rights: "Justera administratörsrätt",
  deactivate_company: "Inaktivera företag",
  remove_employees: "Ta bort anställda",
  remove_members: "Ta bort medlemmar",
  no_user_found: "Ingen användare hittades!",
  approve: "Godkänn!",
  deselect_all: "Avmarkera alla",
  select_all: "Markera alla",
  translation_on_building_projects: "Översättning i projekt",
  reported_capacities: "Rapporterade tjänster",
  up_to_50m_exact: "Upp till 50m exakt",
  company_details_service: "Företagets tjänster",
  company_contact: "Företagskontakt",
  invite_with_link: "Bjud in till Kjuup",
  share_link: "Dela länk",
  share_company_link: "Dela länk",
  qr_code: "QR-kod",
  copy_link: "Kopiera länk",
  cancel_link: "Avbryt länk",
  who_has_confirmed_services: "Vem har bekräftat dina tjänster?",
  projectss: "Projekt",
  add_services: "Lägg till tjänster",
  services: "Tjänster",
  save_text: "Spara",
  share_on: "Dela på:",
  articlen: "Artikel",
  invite_user_to_confirm_service:
    "Bjud in användare att bekräfta tjänster till företaget.",
  link_copied: "Länk kopierad!",
  email_copied: "E-post kopierad!",
  personal_article: "Personlig artikel",
  company_article: "Företagsartikel",
  characters_remaining: "Återstående tecken",
  optional_information: "Valfri information",
  project: "Projekt",
  projects: "Projekt...",
  abort: "Kassera",
  preview: "Förhandsgranska",
  post: "Publicera",
  of: "av",
  remove: "Ta bort",
  free_capacity: "Jobbportal",
  current_status_overview: "Översikt över nuvarande status",
  report_capacities: "Rapportera tjänster",
  report_text: "Rapportera",
  search_capacities: "Hitta entreprenörer",
  add_project_user: "Lägg till projektanvändare",
  media: "Media",
  links: "Länkar",
  docs: "Dokument",
  featured_products: "Utvalda produkter...",
  title: "Titel",
  text: "Text",
  feed_details: "Feed-detaljer",
  add_employee: "Lägg till anställd",
  latest: "Senaste",
  my_projects: "Mina projekt",
  cancel: "Avbryt",
  continue: "Fortsätt",
  role_in_the_building_industry: "Roll i byggindustrin",
  als: "som",
  join: "gå med",
  find: "Hitta",
  request_to_join_a_company: "Begäran att gå med i företaget",
  wants_to_join_the_company: "vill gå med i företaget",
  filter_by: "Filtrera efter",
  ok: "Ok",
  close: "Stäng",
  weekly_statistics: "Veckostatistik",
  is_following_you: "följer dig.",
  as: "som",
  has_joined_the: "har gått med i företaget",
  has_looked_at_your_profile: "har tittat på din profil.",
  time: "Tid",
  in_searches_in_past_week: "i sökningar förra veckan.",
  has_liked_your_article: "har gillat din artikel.",
  has_published_a_new_article: "har publicerat en ny artikel.",
  you: "Du",
  all_views: "Alla visningar",
  all_profile_views: "Alla profilvisningar",
  mutual_company: "gemensamt företag",
  artical_text: "Skriv artikel...",
  you_have_appeared: "Du har dykt upp",
  your_request_at_the_company: "Din begäran på företaget",
  times_you_have_appeared_in_searches: "gånger du har dykt upp i sökningar",
  appear_more_often_in_searches: "Dyka upp oftare i sökningar",
  you_have_been_found: "Du har hittats",
  improve_profile: "Förbättra profil",
  choose_existing_contact_for_single_chat:
    "Välj befintlig kontakt för enkel chatt:",
  in_order_to_add_new_contacts:
    "För att lägga till nya kontakter, vänligen sök efter nya kontakter på profilsidan.",
  times_in_searches_in_the_last_week:
    "gånger i sökningar förra veckan. Uppdatera din profil och lägg till ytterligare detaljer för att bli lättare att hitta.",
  has_been_confirmed: "har bekräftats.",
  have_joined_the: "har gått med i  ",
  building_project: " byggprojekt.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Välj företaget du kommer att representera. Detta kommer att visas för andra deltagare.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Välj företaget du kommer att representera. Detta kommer att visas för andra deltagare.",
  select_internal_section: "Vänligen välj intern sektion",
  select_profile_image: "Välj profilbild",
  share_user: "Dela användare",
  contact_sender_message:
    "Dela denna länk för att bjuda in en icke-medlem av Kjuup till Kjuup. Denna länk kan användas av flera personer för att registrera sig.",
  project_sender_message:
    "Dela denna länk för att bjuda in en icke-medlem av Kjuup till projektet projektnamn. Denna länk kan användas av flera personer för att registrera sig och gå med i projektet projektnamn i Kjuup.",
  company_sender_message:
    "Dela denna länk för att bjuda in en icke-medlem av Kjuup till företaget företagsnamn. Denna länk kan användas av flera personer för att registrera sig och gå med i företaget i Kjuup.",
  contact_receivers_message:
    "Inbjudningslänk för att gå med i Kjuup. Vänligen klicka på länken för att registrera dig för kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Om du installerar Kjuup via Apple App Store måste du klicka på denna länk efter lyckad nedladdning för att kunna registrera dig.",
  project_receivers_message:
    "Inbjudningslänk för att gå med i projektet projektnamn i Kjuup. Vänligen klicka på länken för att registrera dig för Kjuup och gå med i projektet projektnamn.",
  company_receivers_message:
    "Inbjudningslänk till företaget företagsnamn i Kjuup. Vänligen klicka på länken för att registrera dig för Kjuup och gå med i företaget företagsnamn.",
  sign_in: "Logga in",
  enter_your_email_add: "Ange din e-postadress",
  forgot_password: "Glömt lösenord",
  dont_have_account: "Har du inget konto?",
  register: "Registrera",
  get_app: "Hämta appen",
  registration: "Registrering",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Arkitekt",
  prof: "Prof.",
  first_name: "Förnamn",
  last_name: "Efternamn",
  have_an_account: "Har du ett konto?",
  when_register_you_agree: "När du registrerar dig godkänner du våra",
  term_of_use: "användarvillkor",
  to: ".",
  in_our: "I vår",
  data_policy: "datapolicy",
  they_find_out: "får du reda på,",
  we_provide_store_data: "hur vi samlar in, bearbetar och lagrar information.",
  leaving_company_text:
    "Vill du verkligen lämna företaget? När du lämnar företaget lämnar du också alla associerade projekt och chattgrupper. Du kan gå med i dessa projekt igen med ett annat företag när som helst.",
  delete_profile_text:
    "Vill du verkligen radera din profil? När du raderar din profil kommer alla anslutningar till företag, projekt och chattar att tas bort. Du kan skapa en ny profil när som helst.",
  confirm: "Bekräfta",
  reject: "Avvisa",
  requet_to_leave: "Begäran att lämna",
  choose: "Välj",
  your_add_member: "Lägg till medlem",
  if_you: "om du",
  can_not_find: "inte kan hitta din kontakt här.",
  please_wait: "Vänligen vänta..",
  imprint_gtc: "Impressum/Allmänna villkor",
  register_confirm_popup: "Verifiera din Kjuup-e-postadress innan du loggar in. Vi har skickat en bekräftelselänk. Om du inte ser den, kontrollera även skräpposten.",
  PENDING_GROUP_USER:
    "kommer endast att ta emot meddelanden efter att inbjudan till projektet har bekräftats. Ett ytterligare meddelande kommer att visas när inbjudan till projektet har bekräftats.",
  PENDING: "Bekräftelse av inbjudan till projektet väntar",
  denied_group_chat: " har nekat inbjudan till projektet och har lämnat denna grupp.",
  // joined_group_chat: " har gått med i rummet och denna grupp.",
  joined_group_chat: " gick med i denna grupp",
  you_joined_group_chat: "Du gick med i denna grupp.",
  Others: "Andra",
  LEFT_GROUP: "har lämnat denna chattgrupp.",
  YOU_LEFT_GROUP: "har lämnat denna chattgrupp.",
  days: "dagar",
  day: "dag",
  hour: "timme",
  hide_project: "Dölj projekt",
  hide_project_popup_text:
    "Om du döljer projekt kan de inte hittas inom Kjuup. Endast medlemmar i projektet kan bjuda in nya användare till projektet.",
  branch: "Gren",
  photo_video_media_lib: "Foto - Video mediebibliotek",
  document: "Dokument",
  location_meeting: "Plats / Möte",
  all_member_of_project: "Alla medlemmar i projektet",
  pending_request: "Väntande projektförfrågningar",
  no_pending_request: "Inga väntande förfrågningar hittades!",
  news_feed: "Nyhetsflöde",
  user_info: "Gruppinfo",
  leave_project: "Lämna projekt",
  media_link_docs: "Filer",
  search_chat: "Sök chatt",
  export_chat_group: "Exportera chattgruppdata från förra månaden",
  request_complete_chat_history: "Begär komplett chatthistorik",
  leave_chat_group: "Lämna chattgrupp",
  add_user_project: "Lägg till användare",
  me: "Jag",
  max_open_one_to_one:
    "För närvarande kan max. 2 en-mot-en chattar öppnas parallellt i nedre och övre sektionen. Totalt är max. 4 en-mot-en chattar möjliga.",
  are_you_sure_you_want_leave_chat:
    "Är du säker på att du vill lämna denna chattgrupp?",
  create_group: "Skapa grupp",
  adding_members: "Lägger till medlemmar...",
  creating_the_chat: "Skapar chatten...",
  finishing_setup: "Slutför...",
  group_name: "Gruppnamn",
  by: "Av:",
  mandetory: "*obligatoriskt",
  delteed: "har raderat sin profil och har lämnat gruppchatt.",
  deleted_direct: "har raderat sin profil och har lämnat chatten.",
  unhidden_message:
    "Om du visar projekt kan de hittas av alla medlemmar i Kjuup.",
  account_deleted: "Kontot har raderats.",
  refuse_company: "Är du säker på att du vill vägra företagsinbjudan?",
  follow_additional: "Följ ytterligare användare",
  f_add:
    "Följ ytterligare användare av Kjuup för att göra dem tillgängliga för direkta meddelanden.",
  c_inv: "Företagsinbjudan(er)",
  invited_o_Company: "Du har blivit inbjuden att gå med i företaget",
  refuse_companyX: "Är du säker på att du vill vägra företagsförfrågan?",
  a_Da: "Konto inaktiverat.",
  has_deactivated: "har inaktiverat sin profil.",
  reactive: "har aktiverat sin profil igen.",
  juup_note: "*Registrering med användarnamn endast tillgänglig för medlemmar av Kjuup+",
  username: "Användarnamn*",
  email_username: "E-post/Användarnamn*",
  sPinText:
    "Vänligen ange en 6-siffrig säkerhetspinkod. Denna pinkod kommer att behövas om du glömmer ditt lösenord och är obligatorisk för att bekräfta ditt konto.",
  DeleteKjuupPlusText:
    "Vill du verkligen radera din profil? När du raderar din profil kommer alla anslutningar till företag, projekt och chattar att tas bort.\n\nInom 48 timmar efter kontoradering kan du aktivera ditt konto igen genom att logga in med användarnamn, lösenord och pinkod.",
  reactive_text:
    "Ditt konto har raderats. Vänligen klicka på Aktivera igen för att aktivera ditt konto igen.",
  rac: "Aktivera igen",
  ac_ss: "Kontot har aktiverats igen framgångsrikt.",
  not_valid_pin: "Pinkod ogiltig",
  only_for_kjuup:
    "*Återställning av lösenord via användarnamn och pinkod endast tillgänglig för Kjuup+ medlemmar.",
  resetPIN: "Återställ pinkod",
  enter_current_pin: "Vänligen ange din nuvarande pinkod",
  enter_new: "Ange ny pinkod",
  pin_to_confirm: "Vänligen ange pinkoden för att bekräfta.",
  change_username: "Återställ användarnamn",
  pp_not_match: "Lösenord och Bekräfta lösenord matchar inte",
  reactive_itself: "Du har aktiverat din profil igen.",
  has_deactivated_itself: "Du har inaktiverat din profil.",
  more_than_two:
    "För närvarande kan direkta meddelanden endast göras med 2 användare parallellt.",
  Chats: "Direkta meddelanden",
  only_in_mobileL:
    "Inbyggda videor kan för närvarande endast laddas upp och publiceras via mobilappen. Vänligen använd videolänkar från Youtube och Vimeo.",
  register_pin_text:
    "Vänligen välj din personliga 6-siffriga pinkod. Denna pinkod kommer att behövas för att aktivera kontots återställningsfunktioner.",
  internal_project: "Intern",
  external_projects: "Extern",
  in_deacticted: "Intern sektion är inaktiverad.",
  create_article: "Skapa artikel",
  new_article_selection: "Skapa artikel för externt nyhetsflöde",
  new_article_selection_internal: "Skapa intern artikel",
  active_trans_title: "Aktivera automatisk översättning?",
  active_trans: "När den är aktiverad kommer alla inkommande chattmeddelanden att översättas till ditt valda applikationsspråk.",
  disable_trans: "Vill du verkligen inaktivera automatisk översättning?",
  allow_access_chat: "Visa full chatthistorik",
  toggle_chat_history_on:
    "Vill du verkligen att användaren ska se full chatthistorik?",
  toggle_chat_history_off:
    "Vill du verkligen att användaren endast ska se chatthistoriken från det att de gick med i chatten?",
  check_selected_settings:
    "Vänligen kontrollera inställningarna för chatthistorik för alla valda användare!",
  chat_from_start_have:
    "Du har gått med i denna grupp. Chatthistoriken har delats.",
  chat_from_start_has:
    "har gått med i denna grupp. Chatthistoriken har delats.",
  Address: "Adress",
  read_by: "Läst av",
  deliver_to: "Levererat till",
  remaining: "återstående",
  message_info: "Meddelandeinfo",
  request_to_join_only: "Begäran att gå med",
  unfollow: "Sluta följa",
  company_username: "Användarnamn",
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "Ta bort mina administratörsrättigheter",
  makeEmp: "Vill du verkligen ta bort företagsadministratörsrättigheter från användaren?",
  remove_my_self:
    "Vill du verkligen ta bort företagsadministratörsrättigheter från ditt konto?",
  makeAdmin: "Vill du verkligen ge användaren företagsadministratörsrättigheter?",
  remove_member: "Ta bort medlem",
  remove_following_confirm: "Vill du verkligen ta bort {name} från listan över följda?",
  remove_follower_confirm: "Vill du verkligen ta bort {name} från dina följare? Om du tar bort honom/henne kommer han/hon inte att informeras.",
  do_you_really_want_to_remove:
    "Vill du verkligen ta bort användarnamnet från företaget?",
  invite_all: "Bjud in alla medlemmar i företaget",
  invite_all_members: "Bjud in alla medlemmar",
  mems: "Alla andra medlemmar",
  dep_loc: "Avdelning/Plats/Lag",
  depAdmin: "Avdelningsadministratör",
  add_remove_admin: "Lägg till/Ta bort företagsadministratörsposition",
  add_remove_dep_admin: "Lägg till/Ta bort avdelningsadministratörsposition",
  remove_employees_dept: "Ta bort anställda från",
  want_to_join_dep:
    "Användarnamn vill gå med i Avdelningen/Platsen/Laget depname för företaget companyname.",
  you_invited:
    "Du har blivit inbjuden att gå med i Avdelningen/Platsen/Laget depname för företaget companyname.",
  dep_remove:
    "Vill du verkligen ta bort administratörsrättigheter för avdelning eller plats från användaren?",
  add_dep:
    "Vill du verkligen ge användaren administratörsrättigheter för avdelningen eller platsen?",
  my_self_dep_remove:
    "Vill du verkligen ta bort avdelningsadministratörsrättigheter från ditt konto?",
  member: "Medlem",
  admin: "Administratör",
  remove_project_admin:
    "Vill du verkligen ta bort medlemmen från projektet?",
  remove_my_self_project: "Vill du verkligen ta bort administratörsrättigheter?",
  remove_member_admin_right:
    "Vill du verkligen ta bort administratörsrättigheter från användaren?",
  add_member_admin_right: "Vill du verkligen lägga till administratörsrättigheter till användaren?",
  add_remove_Poss: "Lägg till/Ta bort administratörsposition",
  forward: "Vidarebefordra",
  edit: "Redigera",
  only_kjuup_plus_can: "Endast Kjuup+ företag kan publicera artiklar.",
  add_images: "Lägg till bild(er)",
  request_confirmation: 'Väntande projektinbjudningar',
  Activity: "Aktivitet",
  latest_messages: "Senaste meddelanden",
  hours: "timmar",
  minute: "minuter",
  seconds: "sekunder",
  days: "dagar",
  yesterday: "igår",
  last_week: "förra veckan",
  next_week: "nästa vecka",
  Last_month: "förra månaden",
  All: "Alla",
  register_plus: "Registrering Plus",
  select_files: "Välj filer",
  monthsFullName: [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  company_deploc_receivers_message:
    "Inbjudningslänk till avdelningen för företaget företagsnamn i Kjuup. Vänligen klicka på länken för att registrera dig för Kjuup och gå med i företaget företagsnamn.",
  no_news: "Inga nyheter tillgängliga",
  reminder: "Påminnelse",
  np_reminder: "Inga uppgifter",
  move_to_reminder: "Flytta till uppgift",
  remove_reminder: "Vill du verkligen ta bort detta meddelande från listan över dina uppgifter?",
  remove_all_reminder: "Ta bort alla uppgifter",
  remove_all_confirm: "Vill du verkligen ta bort alla meddelanden från listan över dina uppgifter?",
  remove_from_reminder: "Ta bort från påminnelse",
  prevent_email: "E-post kan inte användas som Användarnamn.",
  allow_noti: "Vänligen tillåt aviseringar.",
  join_cap: "Gå med",
  pass_minimum:
    "**Lösenord kräver 12 tecken inkl. liten bokstav, stor bokstav, siffra och specialtecken.",
  pass_error: "Vänligen kontrollera lösenordskraven",
  people_that_like_article: "Personer som gillar artikeln.",
  people_who_like_article: "Personer som gillar din artikel.",
  message_delete: "Detta meddelande har raderats.",
  message_edited: "redigerad",
  edit_message: "Redigera meddelande",
  edit_window_expired: "Meddelanden kan bara redigeras inom 10 minuter efter att de skickats.",
  message_edit_save: "Spara",
  copy: "Kopiera",
  bookmark: "Bokmärke",
  add_reaction: "Lägg till reaktion",
  delete_message: "Ta bort meddelande",
  more_options: "Fler alternativ",
  info: "Info",
  link_invite: "Bjud in via länk",
  ll_nkk: "Bjud in till Kjuup",
  selected: "Vald",
  is_active: "Aktiv",
  inactive: "Inaktiv",
  last_online: "senast online {{when}}",
  remove_user_l: "Ta bort",
  link_expire: "Varje genererad länk kommer att vara giltig i 72 timmar.",
  company_language: "Företagsspråk",
  company_language_info:
    "Språkvalet kommer att användas för alla e-postbekräftelser angående företaget.",
  s_image: "bild",
  m_image: "bilder",
  removeMsg: "Tryck för att ta bort",
  block: 'Blockera',
  unblock: 'Avblockera',
  blocks: 'Är du säker på att du vill blockera denna användare?',
  unblocks: 'Är du säker på att du vill avblockera denna användare?',
  bolcked_click_un_block:
    'Du har blockerat denna kontakt. Klicka här för att ta bort blockeringen.',
  you_have_unblocked: 'Du har avblockerat denna kontakt.',
  you_have_blocked: 'Du har blockerat denna kontakt.',
  unblock_to_send: 'Avblockera användare för att skicka meddelande.',
  pilot_text: "Specialiserad AI för byggämnen",
  startup_screen_label: "Startskärm",
  startup_screen_info: "Välj vilken skärm som öppnas när Kjuup startar.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Meddelanden",
  startup_screen_saved: "Startskärm uppdaterad",
email_on: "E-postaviseringar för chattar",
  email_on_grp: "E-postavisering",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktivera eller inaktivera e-postaviseringar för detta projekt. Detta alternativ är endast tillgängligt när \"E-postaviseringar för chattar\" är aktiverat via personliga inställningar.",
  todo_notification_info: "Du får en avisering varje gång en ny uppgift tilldelas dig.",
  info_val: "Du får ett e-postmeddelande om ett nytt chattmeddelande inte läses inom kort tid. Du kan stänga av det för specifika projekt eller chattar i deras inställningar eller i chattgruppens info.",
  email_groups: "Aktivera eller inaktivera e-postaviseringar för denna chatt. Detta alternativ är endast tillgängligt när \"E-postaviseringar för chattar\" är aktiverat via personliga och projektinställningar.",
  add_update_email: "Lägg till/Uppdatera e-post",
  text_to_verifiy: "Alternativet \"E-postaviseringar för chattar\" kan endast aktiveras om du har en verifierad e-postadress i filen.",
  stored_email: "Lagrad e-post: ",
  verify_email: "Bekräftelse väntar!",
  join_call:"Gå med",
  call_is_started:"Samtal har startat",
  start_chat:"Starta direktchatt?",
  project_rooms:"Projekt",
  download_selected:"Ladda ner",
  add_employee_confirm: 'Är du säker på att du vill lägga till denna användare i företaget?',
  invalid_deeplink: "Ogiltig djuplänk-URL. Saknade obligatoriska parametrar.",
  deeplink_error: "Kan inte bearbeta djuplänken. Vänligen försök igen senare.",
  // Reply functionality translations
  reply: "Svara",
  reply_enter: "Ange svar...",
  reply_sent_successfully: "Svar skickat framgångsrikt",
  reply_failed: "Kunde inte skicka svar",
  reply_failed_generic: "Kunde inte skicka svar. Vänligen försök igen.",
  replying_to_message: "Svarar på meddelande",
  cancel_reply: "Avbryt svar",
  voice_message: "Röstmeddelande",
  send: "Skicka",
  cancel: "Avbryt",
  type_your_reply: "Skriv ditt svar...",
  
  // Auto-suggestion translations
  suggested_replies: "Föreslagna svar",
  suggestions_error: "Kunde inte ladda förslag",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Bild — Klicka för att ladda",
  lazy_media_audio: "Röstmeddelande — Klicka för att ladda",
  lazy_media_doc: "Dokument — Klicka för att ladda",
  lazy_media_video: "Video — Klicka för att ladda",
  suggestion_loading_message: "Ett ögonblick. Din text förbereds individuellt för dig.",
  loading_chat_message: "Laddar chatt...",
  
  // Manual ToDo translations
  extracting_message: "Extraherar meddelande...",
  create_todo: "Skapa uppgift",
  create_todo_confirmation: "Vill du skapa en uppgift från detta meddelande?",
  select_project_required: "Vänligen välj ett projekt/grupp",
  only_assigned_can_change_status: "Endast tilldelade användare kan ändra status",
  todo_summary: "Sammanfattning",
  todo_summary_placeholder: "Ange uppgiftssammanfattning...",
  todo_date: "Datum",
  todo_time: "Tid",
  todo_date_hint: "Lämna tomt för att använda ursprungligt meddelandedatum/tid",
  todo_created_success: "Uppgift skapad framgångsrikt",
  todo_creation_failed: "Kunde inte skapa uppgift",
  create: "Skapa",
  
  image: "bild",
  images: "bilder",
  remove_all_images: "Ta bort alla bilder",
  remove_image: "Ta bort bild",
  remove_document: "Ta bort dokument",
  remove_recording: "Ta bort inspelning",
  play_recording: "Spela upp inspelning",
  upload_image: "Ladda upp bild",
  upload_document: "Ladda upp dokument",
  record_audio: "Spela in ljud",
  stop_recording: "Stoppa inspelning",
  stop_recording_text: "Stoppa inspelning",
  please_remove_current_attachment: "Vänligen ta bort nuvarande bilaga för",
  please_upload_image_file: "Vänligen ladda upp en giltig bildfil",
  please_upload_valid_document: "Vänligen ladda upp en giltig dokumentfil",
  searching_messages: "Söker meddelanden...",
  loading_more: "Laddar mer...",
  loading_more_users: "Laddar fler användare...",
  load_more_users: "Ladda fler användare",
  no_more_users_to_load: "Inga fler användare att ladda",
  no_messages_found: "Inga meddelanden hittades",
  try_different_keyword: "Prova ett annat nyckelord eller kontrollera din stavning.",
  search_messages: "Sök meddelanden, chattgrupper, projekt och användare...",
  todo: "Uppgift",
  np_todo: "Inga uppgifter",
  move_to_todo: "Spara som uppgift",
  remove_todo: "Vill du verkligen ta bort uppgiften?",
  remove_all_todo: "Ta bort alla uppgifter",
  remove_all_todo_confirm: "Vill du verkligen ta bort alla uppgifter?",
  add_to_todo: "Lägg till i uppgift",
  remove_from_todo: "Ta bort från uppgift",
  confirm: "Bekräfta",
  ok: "Ok",
  read_more: "Läs mer",
  show_less: "Visa mindre",
  show_more: "Visa mer",
  audio: "Ljud",
  video: "Video",
  // Notification Settings
  notification_schedule: "Aviseringsschema",
  notification_schedule_desc: "Du kommer endast att ta emot push- och e-postaviseringar under de timmar du väljer. Utanför dessa tider pausas de.",
  learn_more: "Läs mer",
  allow_notifications: "Tillåt aviseringar:",
  every_day: "Varje dag",
  weekdays: "Vardagar (måndag till fredag)",
  custom: "Anpassad",
  monday: "Måndag",
  tuesday: "Tisdag",
  wednesday: "Onsdag",
  thursday: "Torsdag",
  friday: "Fredag",
  saturday: "Lördag",
  sunday: "Söndag",
  to: "till",
  notification_settings: "Aviseringar",
  notification_settings_saved: "Aviseringsinställningar sparade framgångsrikt",
  notification_settings_error: "Kunde inte spara aviseringsinställningar",
  unavailability_note: "Frånvaromeddelande",
  unavailability_description: "Ställ in ett frånvaromeddelande. Medan det är aktivt visas meddelandet för andra i alla dina chattar och aviseringar pausas.",
  unavailability_start_date: "Startdatum",
  unavailability_end_date: "Slutdatum",
  unavailability_message: "Meddelande",
  unavailability_message_hint: "Använd {endDate} som platshållare för ditt returdatum.",
  unavailability_replacement: "Ersättningskontakt",
  unavailability_replacement_placeholder: "Ange användar-ID för brådskande ärenden",
  unavailability_replacement_current: "Nuvarande ersättare",
  unavailability_replacement_hint: "Om det är inställt visas en länk för att kontakta denna person för brådskande ärenden i ditt frånvaromeddelande.",
  unavailability_replacement_none: "Ingen ersättare (valfritt)",
  unavailability_contact_urgent: "För brådskande ärenden kontakta",
  unavailability_default_message: "Jag är för närvarande inte på kontoret och har inte tillgång till Kjuup. Jag är tillgänglig igen från {endDate} och återkommer då.",
  unavailability_save: "Spara",
  unavailability_deactivate: "Inaktivera",
  unavailability_active_until: "Aktivt till",
  unavailability_saved: "Frånvaromeddelande sparat",
  unavailability_save_error: "Det gick inte att spara frånvaromeddelandet",
  unavailability_deactivated: "Frånvaromeddelande inaktiverat",
  unavailability_end_date_required: "Slutdatum krävs",
  start_time_before_end_time: "Starttid måste vara före sluttid",
  loading: "Laddar",
  disabled: "Inaktiverad",
  enable: "Aktivera",
  disable: "Inaktivera",
  forwarded: "Vidarebefordrad",
  message_forwarded: "Meddelande vidarebefordrat!",
  // Schedule Article
  schedule_article_post: "Schemalägg artikelpublicering",
  date: "Datum",
  time: "Tid",
  scheduled_for_publication: "Schemalagd för publicering",
  article_will_be_published_on: "Artikeln kommer att publiceras:",
  reset_selection: "Återställ val",
  continue: "Fortsätt",
  cancel: "Avbryt",
  // Member Selection
  error_loading_members: "Fel vid laddning av medlemmar",
  please_fill_all_fields: "Vänligen fyll i alla fält",
  invalid_email: "Ogiltig e-postadress",
  member_added_successfully: "Medlem tillagd framgångsrikt",
  error_onboarding_user: "Fel vid tillägg av användare",
  error_creating_chat: "Fel vid skapande av chatt",
  error_creating_group: "Fel vid skapande av grupp",
  new_group: "Ny grupp",
  please_select_or_enter_group_name: "Vänligen välj en grupp eller ange ett gruppnamn",
  please_select_or_enter_room_name: "Vänligen välj ett projekt eller ange ett projektnamn",
  error_creating_room: "Fel vid skapande av projekt",
  error_opening_chat: "Fel vid öppning av chatt",
  privacy_modal_text: "Välj \"Privat\" endast om chatten inte innehåller relevant professionellt innehåll för projektledaren.",
  not_private: "Inte privat",
  private: "Privat",
  error_loading_groups: "Fel vid laddning av grupper",
  automatic_chat_export: "Automatisk chattexport",
  automatic_chat_export_info: "Efter aktivering kommer chatthistoriken automatiskt att skickas till den angivna e-postadressen varje månad.",
  automatic_chat_export_no_email: "För att aktivera automatisk chattexport måste du först lägga till en e-postadress. Du kan lägga till din e-postadress i de personliga inställningarna.",
  enter_email: "Ange e-post",
  update: "Uppdatera",
  confirm: "Bekräfta",
  export_to_email: "Exporten går till följande e-post.",
  start_chat_button:"Nytt meddelande",
  matching_existing_chats: "Matchande befintliga chattar",
  subject: "Ämne",
  add_subject: "Lägg till ämne",
  chat_subject: "Chattämne:",
  set_project_room: "Ange projekt",
  matching_existing_project_rooms: "Matchande befintliga projekt",
  name_project_room: "Namnge projekt",
  professional_or_private: "Professionellt eller privat",
  professional: "Professionellt",
  privacy_modal_text_updated: "Välj \"Privat\" endast om chatten inte innehåller relevant professionellt innehåll för projektledare. Privata chattar är inte synliga för projektledare.",
  create_internal_chat: "Extern - eller intern chatt?",
  internal_chat_description: "Endast anställda i ditt företag kan läggas till i interna chattar.",
  yes: "Ja",
  no: "Nej",
  chat_is_being_created: "Chatten skapas...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Vill du verkligen kasta ändringarna i den här artikeln?",
  please_enter_article_title: "Vänligen ange artikelns titel först.",
  please_add_mandatory_fields: "Vänligen lägg till alla obligatoriska fält",
  product_label: "Produkt:",
  no_companies_found: "Inga företag hittades",
  visible_to_all_followers: "Synlig för alla Kjuup-medlemmar",
  only_visible_to_employees: "Synlig endast för anställda",
  something_went_wrong: "Något gick fel, vänligen försök igen",
  please_select_department: "Vänligen välj avdelning/plats",
  schedule: "Schemalägg",
  please_select_future_date_time: "Vänligen välj ett framtida datum och tid för att schemalägga artikeln.",
  please_select_different_date_time: "Vänligen välj ett annat datum eller tid för att schemalägga artikeln.",
  please_select_later_time: "Vänligen välj en tid senare än den nuvarande tiden för idag.",
  unpin_article: "Ta bort fäst artikel",
  pin_article: "Fäst artikel",
  and: "och",
  others: "andra",
  at: "vid",
  // Chat mute/unmute translations
  mute: "Tysta",
  unmute: "Avtysta",
  chat_muted_successfully: "Chatten tystades framgångsrikt",
  chat_unmuted_successfully: "Chatten avtystades framgångsrikt",
  mute_chat_confirm: "Vill du verkligen tysta denna chatt? Du kommer inte längre att ta emot aviseringar för nya meddelanden.",
  unmute_chat_confirm: "Vill du verkligen avtysta denna chatt? Du kommer att ta emot aviseringar för nya meddelanden igen.",
  please_select_group_to_forward: "Vänligen välj grupp för att vidarebefordra meddelande",
  // Company translations
  record_not_found: "Post hittades inte!",
  please_select_position: "Vänligen välj position",
  delete_article_confirm: "Är du säker på att du vill radera denna artikel?",
  delete_company_service_confirm: "Är du säker på att du vill radera företagets tjänst?",
  block_translation_confirm: "Vill du verkligen blockera automatisk översättning i projekt för alla medlemmar i företaget",
  unblock_translation_confirm: "Vill du verkligen avblockera automatisk översättning i projekt för alla medlemmar i företaget",
  please_select_file: "Vänligen välj en fil att ladda upp",
  role_in_building_industry: "Roll i byggindustrin*",
  invalid_email_address: "Ogiltig e-postadress",
  please_enter_password: "Vänligen ange lösenord",
  password_change_email_sent: "Ett e-postmeddelande har skickats till din Kjuup e-post. Bekräfta ditt nya lösenord genom att klicka på bekräftelselänken i e-postmeddelandet.",
  please_enter_username: "Vänligen ange användarnamn",
  username_same_as_before: "Användarnamnet kan inte vara detsamma som tidigare",
  profile_deleted_successfully: "Profil raderad framgångsrikt",
  hardware_requirements: "Hårdvarukrav",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU-hastighet min. 2GHz<br/>• Windows 7 eller högre / alla macOS-versioner",
  submitting: "Skickar...",
  signing_in: "Loggar in...",
  please_enter_service_name: "Vänligen ange tjänstens namn",
  something_went_wrong_error: "Aaaah! Något gick fel...",
  something_went_wrong_try_again: "Tyvärr, något gick fel där. Försök igen",
  position_label: "Position:",
  loading_room: "Laddar projekt...",
  navigating_to_room: "Navigerar till projektet",
  loading_chat: "Laddar chatt...",
  translate: "Översätt",
  show_original: "Visa original",
  saving: "Sparar...",
  language_selection_info: "Språkvalet används för alla e-postbekräftelser relaterade till företaget.",
  // Navigation bar labels
  nav_call: "Ring",
  nav_home: "Hem",
  nav_messages: "Meddelanden",
  nav_todo: "Uppgifter",
  nav_rooms: "Projekt",
  nav_all_rooms: "Alla projekt",
  pinned_rooms_max: "Du kan fästa upp till 10 projekt.",
  pinned_room_unpin: "Lossa",
  pinned_rooms_drop: "Dra ditt projekt hit för snabbval",
  nav_profile: "Profil",
  nav_company: "Företag",
  nav_company_documents: "Dokument",
  nav_logout: "Logga ut",
  // Create message dialog
  add_member_title: "Lägg till medlem",
  continue_btn: "Fortsätt",
  search_placeholder: "Sök",
  no_members_found: "Inga medlemmar hittades",
  no_groups_found: "Inga grupper hittades",
  no_rooms_found: "Inga projekt hittades",
  search_users_tab: "Användare",
  search_documents_tab: "Dokument",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Inga filer",
  no_documents_available: "No documents",
  searching_users: "Söker användare...",
  no_users_found: "Inga användare hittades",
  search_emails_tab: "E-post",
  searching_emails: "Söker e-post...",
  no_emails_found: "Inga e-postmeddelanden hittades",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Namnlös grupp",
  unnamed_room: "Namnlöst projekt",
  all_members: "Alla",
  room_label: "Projekt:",
  subject_label: "Ämne:",
  no_members: "Inga medlemmar",
  // Loading states for room creation
  creating_structure: "Skapar din struktur",
  opening_chat: "Öppnar chatten",
  please_wait: "Vänligen vänta...",
  // ToDo page translations
  loading_todo: "Laddar ToDo...",
  task_updated: "Uppgift uppdaterad",
  error_updating_task: "Fel vid uppdatering av uppgift",
  task_deleted: "Uppgift raderad",
  error_deleting_task: "Fel vid radering av uppgift",
  delete_task_confirm: "Är du säker på att du vill radera denna uppgift?",
  description_label: "Beskrivning",
  description_placeholder: "Ange beskrivning...",
  date_time_label: "Datum & Tid",
  save_hint: "Ctrl+Enter för att spara, Esc för att avbryta",
  edit_label: "Redigera",
  delete_label: "Radera",
  todo_list_title: "Uppgifter",
  tasks_count: "uppgifter",
  search_placeholder_todo: "Sök...",
  select_task_to_open_chat: "Välj en uppgift för att öppna chatten",
  today: "Idag",
  yesterday: "Igår",
  time_suffix: "", // Empty for Swedish (24h format doesn't need suffix)
  from_chat: "Källuppgift",
  assigned_to: "Tilldelad till",
  assign_users: "Tilldela användare",
  no_users_assigned: "Inga användare tilldelade",
  assign: "Tilldela",
  assign_to: "Tilldela till...",
  navigate_to_chat: "Navigera till chatt",
  navigate_to_email: "Gå till e-post",
  show_original_message: "Visa källa",
  hide_original_message: "Dölj källa",
  status_pending: "Väntande",
  status_in_progress: "Pågår",
  status_completed: "Slutförd",
  show: "Visa",
  close: "Stäng",
  status_confirmed: "Bekräftad",
  log_todo_created: "Uppgift skapad",
  log_todo_confirmed: "Uppgift bekräftad",
  log_todo_deleted: "Uppgift raderad",
  log_todo_updated: "Uppgift uppdaterad",
  log_description_updated: "Beskrivning uppdaterad",
  log_deadline_updated: "Deadline uppdaterad",
  log_assigned_to: "Tilldelad till {name}",
  log_unassigned_from: "Borttagen från {name}",
  log_assignment_added: "Tilldelning tillagd: {name}",
  log_assignment_removed: "Tilldelning borttagen: {name}",
  log_status_updated: "Status ändrad från {from} till {to}",
  log_status_changed: "Status ändrad",
  log_status_changed_to: "Status ändrad till {status}",
  log_changed_status_to: "Ändrade statusen till:",
  log_for_user: "för användare:",
  log_user_updated_status: "Användaren uppdaterade sin uppgiftsstatus",
  log_changed_date_to: "Ändrade datumet till:",
  log_changed_description_to: "Ändrade beskrivningen till:",
  log_moved_to: "Flyttad till {status}",
  todo_status_updated_from: "från",
  todo_status_updated_to: "till",
  filter_pending: "Väntande",
  filter_confirmed: "Bekräftad",
  my_list: "Min dag",
  todo_adjust_list: "Redigera lista",
  apply: "Tillämpa",
  filter_assigned_to_me: "Mina uppgifter",
  filter_assigned_by_me: "Delegerad",
  todo_project_label: "Projekt:",
  assigned_users: "Tilldelade användare:",
  todo_chat_label: "Chatt:",
  history: "Historik",
  todo_assigned_by: "Tilldelad av:",
  todo_assigned_push: "Tilldelad ToDo:",
  todo_assigned_push_empty: "Ett nytt ToDo har tilldelats dig.",
  search_groups: "Grupper",
  search_chat_groups: "Chattgrupper",
  search_project_room: "Projekt",
  search_messages_tab: "Meddelanden",
  searching_groups: "Söker grupper...",
  searching_rooms: "Söker projekt...",
  no_groups_found: "Inga grupper hittades",
  no_rooms_found: "Inga projekt hittades",
  // ToDo filter translations
  todo_filters: "Filter",
  todo_filter_by_project: "Filtrera efter projekt",
  todo_status: "Status",
  todo_assignment: "Tilldelning",
  todo_filter_by_user: "Filtrera efter tilldelad person",
  todo_active_filters: "Aktiva filter:",
  todo_progress: "Framsteg",
  todo_my_list_empty: "Din dag är tom",
  todo_my_list_empty_hint: "Klicka på knappen ovan för att lägga till uppgifter",
  create_poll: "Omröstning",
  poll_question_label: "FRÅGA",
  poll_question_placeholder: "Ställ en fråga",
  poll_options_label: "ALTERNATIV",
  poll_option: "Alternativ",
  poll_add_option: "Lägg till alternativ",
  poll_allow_multiple: "Tillåt flera svar",
  poll_multiple_allowed: "Välj ett eller flera alternativ",
  poll_select_option: "Välj ett alternativ",
  poll_view_votes: "Visa röster",
  poll_vote_singular: "röst",
  poll_vote_plural: "röster",
  poll_votes: "Omröstningsresultat",
  poll_no_votes_yet: "Inga röster än",
  transcript_step_processing: "Transkription pågår...",
  ai_transcript_tab: "AI-Transkription",
  ai_transcript_info: "Endast tillgänglig för röstmeddelanden skapade efter 09.03.2026.",
  transcript_more: "...mer",
  transcript_less: "...mindre",
  ki_transcript_voice_message: "KI-Transkript av röstmeddelande",
  ki_image_analysis: "AI-stödd bildanalys",
  type_message: "Skriv ett meddelande",
  email_tab_messages: "Meddelanden",
  email_tab_email: "E-post",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-postkonton",
  email_connect_gmail: "Anslut Gmail",
  email_connect_outlook: "Anslut Outlook",
  email_no_accounts: "Inga e-postkonton anslutna",
  email_no_accounts_hint: "Anslut ett e-postkonto i dina profilinställningar",
  email_no_messages: "Inga e-postmeddelanden",
  email_from: "Från",
  email_to: "Till",
  email_subject: "Ämne",
  email_disconnect: "Koppla från",
  email_disconnect_confirm: "Är du säker på att du vill koppla från detta e-postkonto? Alla synkroniserade e-postmeddelanden kommer att tas bort.",
  email_account_disconnected: "E-postkontot har kopplats bort",
  email_account_disconnect_failed: "Kunde inte koppla bort kontot",
  email_connecting: "Ansluter...",
  email_account_connected: "Konto anslutet",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Gå till inställningar",
  email_date: "Datum",
  email_reply: "Svara",
  email_forward: "Vidarebefordra",
  email_copy_text: "Kopiera text",
  email_text_copied: "Kopierad!",
  email_text_copy_failed: "Det gick inte att kopiera texten.",
  email_delete: "Radera",
  email_not_spam: "Inte skräppost",
  email_not_spam_success: "E-post flyttad till inkorgen.",
  email_not_spam_failed: "Kunde inte flytta till inkorgen.",
  email_delete_confirm: "Är du säker på att du vill radera detta e-postmeddelande?",
  email_delete_from_folder: "Är du säker på att du vill radera från {folder}?",
  email_delete_permanent_from_folder:
    "Är du säker på att du vill radera permanent från {folder}? Denna åtgärd kan inte ångras.",
  email_save_draft_confirm: "Vill du spara detta e-postmeddelande som utkast?",
  email_save_draft: "Spara utkast",
  email_discard: "Radera",
  email_back_to_compose: "Tillbaka till utkast",
  email_draft_saved: "Utkast sparat.",
  email_draft_save_failed: "Kunde inte spara utkast.",
  email_loading: "Laddar e-post...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Välj",
  email_attachment_singular: "Bilaga",
  email_attachment_plural: "Bilagor",
  email_back: "Tillbaka",
  email_download: "Ladda ner",
  email_close: "Stäng",
  email_preview: "Förhandsvisning",
  email_preview_not_available: "Förhandsvisning inte tillgänglig",
  email_preview_failed: "Förhandsvisning inte tillgänglig",
  select_attachments: "Välj bilagor",
  email_loading_preview: "Laddar förhandsvisning...",
  email_mark_unread_failed: "e-post kunde inte markeras som oläst.",
  email_delete_failed: "e-post kunde inte raderas.",
  filter_all: "Alla",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Direkta meddelanden",
  my_notes: "My Space",
  filter_internal_groups: "Interna gruppchatter",
  filter_external_groups: "Externa gruppchatter",
  filter_group_chats: "Gruppchatter",
  filter_groups_internal: "Interna",
  filter_groups_external: "Externa",
  filter_unread_only: "Endast olästa",
  room_daily_briefing_info: "När funktionen är aktiverad skapas en rapport för projektet var 24:e timme vid den tid som anges i dina personliga inställningar — men bara om det har funnits aktivitet under perioden.",
  email_select_all: "Markera alla",
  email_deselect_all: "Avmarkera alla",
  email_reply_all: "Svara alla",
  email_reply_placeholder: "Skriv ditt svar...",
  email_forward_placeholder: "Lägg till ett meddelande...",
  email_edit_draft: "Redigera utkast",
  email_attach: "Bifoga",
  email_attachment_from_original: "Från originalmeddelandet",
  email_remove: "Ta bort",
  email_drop_files: "Släpp filer för att bifoga",
  email_loading_attachments: "Laddar bilagor...",
  email_archive: "Arkivera",
  mark_unread: "Markera som oläst",
  mark_read: "Markera som läst",
  email_all_accounts: "Alla konton",
  email_error: "Fel",
  email_delete_email_failed: "Det gick inte att radera e-postmeddelandet.",
  enter_url: "Ange URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Prenumerera nu',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MÅNADS GRATIS PROVPERIOD',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Ingen betalning idag. Inga kreditkortsuppgifter begärs innan den betalda prenumerationen startar.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Hantera alla e-postkonton direkt i Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI skriver svar – du bekräftar bara',
  kjuup_io_feature_tasks: 'Uppgifter & kalender alltid automatiskt uppdaterade',
  kjuup_io_choose_plan: 'Välj plan',
  kjuup_io_plan_monthly: 'Månadsvis',
  kjuup_io_plan_yearly: 'Årsvis',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Säkrat av Stripe · kan sägas upp när som helst',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Betalningen har tagits emot. Ditt abonnemang aktiveras…',
  kjuup_io_toast_activating_soon: 'Betalningen har tagits emot. Ditt abonnemang aktiveras inom kort.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} timmar kvar',
  kjuup_io_trial_left_hour: '1 timme kvar',
  kjuup_io_trial_left_minutes: '{count} minuter kvar',
  kjuup_io_trial_left_minute: '1 minut kvar',
  kjuup_io_trial_left_seconds: '{count} sekunder kvar',
  kjuup_io_trial_left_second: '1 sekund kvar',
  kjuup_io_trial_ending_now: 'Din provperiod tar slut…',
  kjuup_io_request_timeout: 'Anslutningen tog för lång tid. Försök igen.',
  kjuup_io_info_days_free: '{days} dagar helt gratis – din prenumeration startar först efter provperioden.',
  kjuup_io_discount_total: 'Din rabatt: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Personlig: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Stäng',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Din kostnadsfria provperiod har tagit slut',
  kjuup_io_trial_ended_body: 'Prenumerera på Kjuup.io för att fortsätta använda e-post och andra premiumfunktioner.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Din kostnadsfria provperiod har startat',
  kjuup_io_toast_trial_fail: 'Det gick inte att starta provperioden',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / månad',
  kjuup_io_save_amount_year: 'Spara {price} per år',
  kjuup_io_billed_annually_amount: '{price} faktureras årligen',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Det här får du:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Inget kreditkort krävs – starta direkt utan betalningsuppgifter.',
  kjuup_io_info_cancel_anytime: 'Säg upp när som helst – inget åtagande, ingen risk.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Faktureringsperiod',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Betalningsmetoden har sparats. Du debiteras när provperioden tar slut.',
  calendar_sync_info: 'Synkronisera automatiskt alla Kjuup ToDos med din kalender.',
  calendar_no_accounts: 'Ingen kalender ansluten ännu.',
  article_new_badge: 'NYTT',
  article_new_posts: '{0} nya inlägg',
  documents: 'Dokument',
  add_documents: 'Lägg till dokument',
  no_preview_available: 'Ingen förhandsgranskning tillgänglig',
  no_preview_hint: 'Den här filtypen kan inte förhandsgranskas, men den skickas ändå.',
  max_documents_reached: 'Du kan bifoga upp till 10 dokument åt gången.',
  open_file: 'Öppna fil',
  twofa_title: 'Tvåfaktorsautentisering',
  twofa_method_totp: 'Autentiseringsapp',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-post',
  twofa_enter_app: 'Ange den 6-siffriga koden från din autentiseringsapp.',
  twofa_enter_sms: 'Ange den 6-siffriga koden vi skickade via SMS.',
  twofa_enter_email: 'Ange den 6-siffriga koden vi skickade till din e-post.',
  twofa_resend: 'Skicka koden igen',
  twofa_try_another: 'Prova en annan metod',
  twofa_remember_device: 'Fråga inte igen på den här enheten på 30 dagar',
  twofa_sent: 'Vi har skickat en kod.',
  twofa_invalid_code: 'Koden är fel. Försök igen.',
  twofa_something_wrong: 'Något gick fel. Försök igen.',
  twofa_method_unavailable: 'Den metoden är inte tillgänglig.',
  twofa_on_desc: 'Tvåfaktorsautentisering är på. Du behöver en kod varje gång du loggar in.',
  twofa_off_desc: 'Lägg till ett andra steg efter ditt lösenord. Autentiseringsappar är säkrast.',
  twofa_methods: 'Metoder',
  twofa_on: 'På',
  twofa_add: 'Lägg till',
  twofa_default_method: 'Standardmetod',
  twofa_default: 'Standard',
  twofa_turn_off: 'Stäng av',
  twofa_disable_hint: 'Ange ditt lösenord och en aktuell kod för att stänga av tvåfaktorsautentisering.',
  twofa_disable_need: 'Ange ditt lösenord och en verifieringskod.',
  twofa_code_placeholder: '6-siffrig kod eller reservkod',
  twofa_send_code: 'Skicka en kod',
  twofa_primary_updated: 'Standardmetoden har uppdaterats.',
  twofa_disabled: 'Tvåfaktorsautentisering är nu av.',
  twofa_enabled: 'Tvåfaktorsautentisering är nu aktiverat.',
  twofa_totp_help: 'Skanna den här QR-koden med Google Authenticator, Authy eller 1Password. Du kan också ange nyckeln manuellt.',
  twofa_secret_copied: 'Nyckeln kopierades',
  twofa_sms_help: 'Ange ditt nummer i internationellt format. Vi skickar en 6-siffrig kod via SMS.',
  twofa_email_help: 'Vi skickar en 6-siffrig kod till e-postadressen på ditt konto.',
  twofa_backup_title: 'Reservkoder',
  twofa_backup_help: 'Spara dessa engångskoder på ett säkert ställe. Varje kod kan användas en gång om du tappar telefonen.',
  twofa_copy_codes: 'Kopiera koder',
  twofa_codes_copied: 'Reservkoderna kopierades',
  twofa_regenerate: 'Hämta nya reservkoder',
  twofa_regenerate_hint: 'Detta ersätter oanvända reservkoder. Ange ditt lösenord och en aktuell kod.',
  twofa_backup_remaining: '{n} oanvända reservkoder kvar',
  twofa_new_codes: 'Nya reservkoder',
  twofa_sms_unavailable: 'SMS-koder är inte tillgängliga ännu.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Tilldelade Kjuup-uppgifter kopieras till ett projekt som heter Kjuup i din Todoist. Ändringar i Todoist kopieras inte tillbaka.",
  todoist_connect: "Anslut Todoist",
  todoist_connected: "Todoist ansluten",
  todoist_connect_failed: "Det gick inte att ansluta Todoist",
  todoist_disconnect: "Koppla från",
  todoist_disconnected: "Todoist frånkopplad",
  todoist_disconnect_confirm: "Koppla från Todoist? Uppgifter som redan finns i Todoist blir kvar. Synken stoppas.",
  todoist_sync_now: "Synka nu",
  todoist_syncing: "Synkar…",
  todoist_sync_done: "Synkning klar",
  todoist_sync_failed: "Synkning misslyckades",
  todoist_auth_error: "Anslut Todoist igen för att fortsätta synka.",
  todoist_last_sync: "Senaste synk",
  todoist_not_connected: "Todoist är inte ansluten",
  todoist_auth_url_failed: "Kunde inte öppna Todoists auktoriseringssida.",
  recommend_text: "Gå med i Kjuup för att hålla kontakten och hålla ordning på din kommunikation. Samla dina kanaler, håll meddelanden i rätt projekt och börja varje morgon med en sammanfattning och dina uppgifter – allt synkroniserat med apparna du redan använder. Kom igång gratis:",
  pro_auth_signin_title: 'Välkommen tillbaka',
  pro_auth_signin_sub: 'Logga in med din jobb-e-post.',
  pro_auth_email_or_username: 'E-post eller användarnamn',
  pro_auth_email_placeholder: 'namn@foretag.se',
  pro_auth_forgot_password: 'Glömt lösenordet?',
  pro_auth_create_account: 'Skapa konto',
  pro_auth_show_password: 'Visa lösenord',
  pro_auth_hide_password: 'Dölj lösenord',
  pro_auth_register_sub: 'Vi skickar dig en länk för att bekräfta din e-post.',
  pro_auth_register_plus_sub: 'Välj ett användarnamn och ett lösenord. Därefter anger du din säkerhets-PIN.',
  pro_auth_check_credentials: 'Kontrollera din e-post och ditt lösenord',
  pro_news_export_pdf: 'Exportera som PDF',
  pro_news_pdf_failed: 'PDF-filen kunde inte skapas.',
  pro_news_pdf_attachments: 'Bilagor',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Ange din e-post så skickar vi dig en länk för att återställa ditt lösenord.',
  pro_auth_send_link: 'Skicka återställningslänk',
  pro_auth_plus_reset: 'Återställ med PIN',
  pro_auth_show_pin: 'Visa PIN',
  pro_auth_hide_pin: 'Dölj PIN',
  v2_auth_plus_only: 'Endast Kjuup+',
  room_action_media: "Filer",
  room_tab_overview: "Översikt",
  room_tab_history: "Historik",
  chat_info_media: "Filer",
  messages: "meddelanden",
  pro_todo_project_required: "Välj ett projekt",
  pro_todo_choose_project: "Vilket projekt är uppgiften för?",
  cockpit_report_delete_confirm: "Ta bort den här dagsrapporten?",
  cockpit_report_deleted: "Dagsrapport borttagen",
  cockpit_tab_company: "Företag",
  cockpit_bookmarked_priorities: "Markerade uppgifter",
  cockpit_load_error: "Cockpit kunde inte laddas.",
  cockpit_retry: "Försök igen",
  cockpit_yesterday: "Igår",
  cockpit_greeting_morning: "God morgon",
  cockpit_greeting_day: "God dag",
  cockpit_greeting_evening: "God kväll",
  cockpit_assistant_q_open: "Vad är öppet idag?",
  cockpit_assistant_q_summarize: "Sammanfatta chatten {{room}}",
  cockpit_assistant_q_overdue: "Vilka uppgifter är försenade?",
  cockpit_assistant_new: "{{n}} nya",
  cockpit_assistant_important: "{{n}} viktiga",
  cockpit_assistant_title: "Kjuup-assistent",
  cockpit_assistant_hint: "Tryck och fråga",
  room_overview_priority_no_detail: "Rapporten ger inga fler detaljer om den här prioriteten.",
  room_overview_priority_from: "Källa: {{name}}",
  room_overview_priority_open_task: "Öppna uppgift",
  cockpit_priority_position: "{{index}} av {{total}} prioriteringar",
  room_overview_today_title: "Viktigt idag",
  room_overview_all_tasks: "Alla",
  room_overview_tasks_empty: "Inga öppna deadlines eller uppgifter",
  room_overview_appointments_empty: "Inga kommande möten",
  room_overview_no_priorities: "Inga öppna prioriteringar i den senaste rapporten.",
  cockpit_report_top5: "Topp 5 prioriteringar",
  cockpit_report_todo_created: "Uppgift skapad",
  cockpit_report_source_missing: "Källmeddelandet hittades inte.",
  delete_bookmarked_priority_confirm: "Vill du verkligen ta bort den här markerade uppgiften?",
  cockpit_report_create_todo: "Skapa uppgift",
  cockpit_priorities_deleting: "Tar bort …",
  cockpit_priorities_select: "Ta bort flera",
  cockpit_report_none: "Inga poster.",
  cockpit_priorities_delete_confirm: "Vill du verkligen ta bort {count} markerade uppgifter?",
  cockpit_priorities_delete_failed: "{count} uppgifter kunde inte tas bort",
  cockpit_priorities_deleted: "{count} uppgifter borttagna",
  cockpit_priorities_selected: "{count} markerade",
  cockpit_channel_connected: "Ansluten",
  cockpit_channel_not_connected: "Inte ansluten",
  cockpit_channel_connect: "Anslut",
  cockpit_channel_chat: "Kjuup-chatt",
  cockpit_channel_active: "Aktiv",
  cockpit_channel_hidden: "Dold",
  cockpit_channel_enable: "Aktivera",
  cockpit_channel_email: "E-post",
  cockpit_channel_check: "Kontrollera anslutningen",
  cockpit_channel_fix: "Kontrollera",
  cockpit_channel_forward: "Vidarebefordringsadress",
  cockpit_channel_not_set_up: "Inte konfigurerad",
  cockpit_channel_set_up: "Konfigurera",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Anslutningen bruten",
  cockpit_channel_importing: "Importerar",
  cockpit_channel_removing: "Kopplar bort",
  cockpit_channel_reconnect: "Anslut igen",
  cockpit_channels_title: "Kanaler",
  cockpit_company_role_super_admin: "Företagsadministratör",
  cockpit_company_role_dept_admin: "Avdelningsadministratör",
  cockpit_company_role_member: "Medarbetare",
  cockpit_company_none: "Inget Kjuup+-företag hittades",
  cockpit_company_eyebrow: "Företag",
  cockpit_company_inactive: "inaktivt",
  cockpit_company_settings: "Företagsinställningar",
  cockpit_company_employees: "Medarbetare",
  cockpit_company_internal_rooms: "Interna projekt",
  cockpit_report_all_projects: "Alla projekt",
  cockpit_report_progress_emails: "Analyserar e-post",
  cockpit_report_progress_chats: "Analyserar chattmeddelanden",
  cockpit_report_progress_documents: "Analyserar bilagor och dokument",
  cockpit_report_progress_tasks: "Analyserar uppgifter",
  cockpit_report_progress_summarizing: "Analyserar innehåll",
  cockpit_report_progress_reading: "Återanvänder redan analyserat innehåll",
  cockpit_report_progress_collecting: "Samlar e-post, chattar och uppgifter från dina projekt",
  cockpit_report_progress_priorities: "Sammanställer prioriteringar, tidsfrister och beslut",
  cockpit_report_progress_queued: "Förbereder rapporten",
  cockpit_report_creating_title: "Din dagsrapport förbereds",
  cockpit_report_progress_count_one: "1 objekt analyserat",
  cockpit_report_progress_count_many: "{{count}} objekt analyserade",
  cockpit_report_progress_hint: "Det tar vanligtvis en till två minuter – du kan fortsätta använda cockpit under tiden.",
  cockpit_report_time_hint: "Dagsrapporten skapas varje dag kl. {{hour}}:00 för de fem mest aktiva projekten.",
  room_overview_priorities_title: "Aktuell status och prioriteringar",
  room_overview_as_of: "Per {{time}}",
  cockpit_report_delete: "Ta bort dagsrapport",
  email_tag_daily_briefing: "Dagsrapport",
  cockpit_report_unread: "Ny",
  cockpit_report_clear_project: "Visa alla projekt",
  cockpit_filter_project: "Projekt",
  cockpit_filter_all_projects: "Alla projekt",
  cockpit_report_recreate: "Skapa dagsrapport igen",
  cockpit_report_hide_previous: "Dölj tidigare dagsrapporter",
  cockpit_report_show_previous: "Visa tidigare dagsrapporter",
  cockpit_report_room_empty: "Ingen dagsrapport för det här projektet ännu",
  cockpit_report_empty: "Ingen dagsrapport ännu",
  cockpit_report_room_empty_hint: "Skapa en dagsrapport bara för det här projektet.",
  cockpit_report_needs_mailbox: "Anslut ett e-postkonto så att Kjuup kan skapa en dagsrapport med automatiska uppgifter.",
  cockpit_report_create: "Skapa dagsrapport",
  cockpit_email_connect: "Anslut e-post",
  cockpit_email_none_title: "Inget e-postkonto anslutet ännu",
  cockpit_email_none_reports: "Anslut din brevlåda så att Kjuup kan koppla inkommande e-post till dina projekt och skapa dagsrapporter med uppgifter.",
  cockpit_email_none_client: "Anslut Gmail, Outlook eller IMAP för att läsa, koppla och besvara e-post direkt i Kjuup.io.",
  cockpit_email_reports_title: "Nuvarande e-postklient",
  cockpit_email_reports_text: "Ingen inkorg i Kjuup.io · {{rooms}} projekt med dagsrapport kl. {{hour}}:00 · inkommande e-post kopplas till dina projekt.",
  cockpit_email_reports_rooms: "Hantera projekt",
  cockpit_email_settings: "E-postinställningar",
  cockpit_email_error_title: "Kontrollera anslutningen",
  cockpit_email_client_title: "Inkorg ansluten",
  cockpit_email_accounts_n: "{{n}} konto anslutet",
  cockpit_email_last_sync: "senaste synkronisering {{when}}",
  cockpit_email_report_at: "Dagsrapport kl. {{hour}}:00",
  cockpit_email_open_inbox: "Öppna inkorgen",
  cockpit_email_eyebrow: "Kjuup-e-post",
  cockpit_email_accounts_label: "Anslutna e-postadresser",
  email_folder_sent: "Skickade objekt",
  email_no_subject: "(Ingen ämnesrad)",
  cockpit_email_detail_loading: "Laddar e-post …",
  cockpit_email_detail_failed: "E-postmeddelandet kunde inte laddas.",
  cockpit_email_detail_empty: "Det här e-postmeddelandet har ingen text.",
  cockpit_personal_settings: "Personliga inställningar",
  cockpit_companies: "Företag",
  cockpit_title: "Cockpit",
  cockpit_back: "Tillbaka till översikten",
  cockpit_day_overview: "Din dag i korthet",
  email_saved_to_project: "E-post sparad i projektet",
  email_classify_need_project: "Ange ett projektnamn",
  cockpit_email_deleted: "E-post borttagen",
  cockpit_email_sent_empty: "Inga skickade e-postmeddelanden ännu.",
  cockpit_email_incoming_empty: "Inga inkommande e-postmeddelanden ännu.",
  cockpit_email_incoming_title: "E-post",
  cockpit_email_incoming_sub: "Koppla inkommande och skickad e-post till dina projekt. Här kan du justera kopplingen.",
  cockpit_email_incoming_unassigned_n: "{{n}} ej kopplade",
  cockpit_email_folder_inbox: "Inkorg",
  cockpit_email_folder_sent: "Skickat",
  cockpit_email_open: "Öppna e-post",
  cockpit_email_incoming_suggested: "Förslag: {{room}}",
  cockpit_email_incoming_apply: "Använd",
  cockpit_email_incoming_adjust: "Justera koppling",
  cockpit_email_incoming_saving: "Sparar …",
  cockpit_email_incoming_unassigned: "Inte kopplad",
  cockpit_email_incoming_show_less: "Visa färre",
  cockpit_email_incoming_show_all: "Visa alla {{n}}",
  cockpit_io_settings: "Kjuup.io-inställningar",
  cockpit_io_settings_sub: "Abonnemang och platser, tilldelning av medarbetare, fakturering och fakturor.",
  products_coming_soon: "Kommer snart",
  cockpit_upsell_io_title: "Ditt kontor som tänker med",
  cockpit_upsell_io_text: "Anslut dina e-postkonton till Kjuup. E-post, bilagor och meddelanden sparas automatiskt i rätt projekt och kan valfritt lagras på din server. Varje dag får du en sammanfattning av alla projekt med de viktigaste punkterna från allt innehåll, och dina uppgifter synkroniseras med din kalender eller to do-app.",
  cockpit_upsell_io_soon_title: "Går inte att boka ännu",
  cockpit_upsell_io_soon_text: "Kjuup.io lanseras snart. Begär information nu – vi meddelar dig så snart du kan boka Kjuup.io.",
  cockpit_upsell_io_planned_price: "Planerat pris",
  cockpit_upsell_io_cta_request: "Begär information",
  kjuup_plus_abo_per_year: "/ år",
  kjuup_plus_abo_per_month: "/ månad",
  kjuup_plus_abo_status_active: "Aktiv",
  kjuup_plus_abo_status_requested: "Uppsägning begärd",
  kjuup_plus_abo_status_past_due: "Betalning förfallen",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abonnemang",
  kjuup_plus_abo_title: "Kjuup+-paket",
  kjuup_plus_abo_seats_free_one: "1 plats kvar",
  kjuup_plus_abo_billing: "Fakturering",
  kjuup_plus_abo_yearly: "Årligen",
  kjuup_plus_abo_monthly: "Månadsvis",
  kjuup_plus_abo_amount: "Belopp",
  kjuup_plus_abo_ends: "Slutar den",
  kjuup_plus_abo_renews: "Nästa förnyelse",
  kjuup_plus_abo_next_invoice: "Nästa faktura",
  kjuup_plus_abo_intro: "Introduktionspris",
  kjuup_plus_abo_pending_tier: "Från nästa förnyelse",
  kjuup_plus_abo_manual: "Kjuup+ är aktivt för ditt företag enligt ett individuellt avtal.",
  kjuup_plus_abo_invoices: "Fakturor",
  kjuup_plus_abo_invoice_paid: "Betald",
  kjuup_plus_abo_invoice_view: "Visa",
  kjuup_plus_abo_invoices_less: "Visa färre",
  kjuup_plus_abo_member_hint: "Fakturering och uppsägning hanteras av era företagsadministratörer.",
  kjuup_plus_abo_withdraw: "Återkalla begäran",
  kjuup_plus_abo_cancel_note: "Anledning (valfritt)",
  kjuup_plus_abo_cancel_send: "Begär uppsägning",
  kjuup_plus_abo_cancel: "Säg upp abonnemanget",
  cockpit_upsell_plus_f1: "Hantera alla medarbetares kommunikationsaktivitet",
  cockpit_upsell_plus_f2: "Informera specifika användargrupper i företaget",
  cockpit_upsell_plus_f3: "Spara interna gruppchattar",
  cockpit_upsell_plus_when_yearly: "vid årlig betalning",
  cockpit_upsell_plus_size_small: "1–50 medarbetare",
  cockpit_upsell_plus_size_large: "51–200 medarbetare",
  cockpit_upsell_plus_title: "Kjuup+ för företag",
  cockpit_upsell_plus_text: "Hantera medarbetare, skrivbehörigheter och företagskommunikation på ett ställe. Interna kanaler stannar hos ditt team, externa kanaler kopplar dig till projektpartner och du kan nå specifika grupper direkt. Utöver Kjuup+ kan du boka Kjuup.io-åtkomst för medarbetargrupper. Kjuup+ och Kjuup.io kan kombineras.",
  cockpit_upsell_plus_size: "Företagsstorlek",
  cockpit_upsell_plus_billing: "Fakturering",
  cockpit_upsell_plus_per_company: "/ företag · månad exkl. moms",
  cockpit_upsell_plus_onboarding: "Kostnader för onboarding/introduktion beror på företagets storlek",
  cockpit_upsell_plus_larger: "Priser för större företag på begäran",
  cockpit_upsell_plus_cta: "Förfrågan utan förpliktelser",
  cockpit_kpi_deadlines_tasks: "Tidsfrister och uppgifter",
  cockpit_kpi_appointments: "Möten",
  cockpit_room_admin: "Projekt- och chatthantering",
  cockpit_room_admin_sub: "Alla företagets projekt med medlemmar, media och chattar.",
  pro_todo_not_found: "Den här uppgiften finns inte längre.",
  cockpit_chip_overdue: "Försenad",
  cockpit_chip_today: "Idag",
  cockpit_calendar_week: "V. {{week}}",
  cockpit_prev_week: "Föregående vecka",
  cockpit_next_week: "Nästa vecka",
  cockpit_chip_requested: "Begärd",
  cockpit_todo_due: "Förfaller {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "från {{name}}",
  cockpit_todo_since: "sedan {{when}}",
  cockpit_todo_no_date: "Inget datum",
  cockpit_todo_mark_done: "Markera som klar",
  cockpit_my_tasks_title: "Mina uppgifter",
  cockpit_today_tasks_group: "Dagens uppgifter",
  cockpit_assign_none: "Ingen tilldelad",
  no_project_found: "Inget projekt hittades",
  cockpit_row_more_actions: "Fler åtgärder",
  needs_date: "Tilldela datum",
  cockpit_assign_proposal: "{{name}} identifierad – tilldela?",
  cockpit_assign_proposal_confirm: "Tilldela",
  cockpit_assign_proposal_dismiss: "Ignorera",
  cockpit_priority_date: "Datum",
  todo_calendar_add: "Lägg till i kalendern",
  todo_calendar_remove: "Ta bort från kalendern",
  cockpit_todo_change_project: "Byt projekt",
  cockpit_todo_set_date: "Ange datum",
  pro_todo_done_confirm: "Vill du verkligen markera den här uppgiften som klar?",
  cockpit_task_delete_failed: "Uppgiften kunde inte tas bort.",
  cockpit_setup_title: "Slutför konfigurationen",
  cockpit_setup_text: "Bestäm om du vill använda chattar och om Kjuup.io ska fungera som e-postklient eller bara med projekt och dagsrapporter.",
  cockpit_setup_cta: "Konfigurera nu",
  cockpit_group_tasks: "Tidsfrister och uppgifter",
  cockpit_group_appointments: "Möten",
  cockpit_report_no_activity: "Det här projektet hade inga nya meddelanden eller e-postmeddelanden de senaste 24 timmarna.",
  cockpit_report_room_unavailable: "Det här projektet är inte tillgängligt.",
  cockpit_report_create_failed: "Dagsrapporten kunde inte skapas.",
  cockpit_report_created: "Dagsrapport skapad",
  addon_enable_confirm: "Aktivera tillägget?",
  addon_enable: "Aktivera",
  addon_enabled: "Tillägg aktiverat",
  nav_email: "E-post",
  nav_my_cockpit: "Min cockpit",
  nav_news: "Nyheter",
  nav_recommend: "Tipsa",
  pro_todo_status_done: "Klar",
  pro_todo_status_open: "Öppen",
  v2_todo_remove: "Ta bort",
  pro_todo_search_people: "Sök personer",
  pro_todo_clear: "Rensa",
  pro_todo_assigned: "(tilldelad)",
  pro_todo_no_people: "Inga personer hittades",
  pro_todo_search_rooms: "Sök projekt",
  pro_todo_no_rooms_match: "Inga projekt matchar ”{{q}}”",
  pro_todo_no_rooms: "Inga projekt hittades",
  pro_todo_activity: "Aktivitet",
  pro_todo_show_less: "Visa färre",
  pro_todo_show_all: "Visa alla ({{n}})",
  pro_todo_due: "Förfaller",
  pro_todo_room: "Projekt",
  pro_todo_select_room: "Välj projekt",
  pro_todo_status: "Status",
  pro_todo_more: "Mer",
  pro_todo_edit_title: "Redigera uppgift",
  pro_todo_description: "Beskrivning",
  pro_todo_created_by: "Skapad av",
  pro_todo_chat: "Chatt",
  navigate_to_source: "Gå till källan",
  todo_calendar_connect_title: "Ingen kalender ansluten",
  todo_calendar_connect_body_web: "Anslut en kalender i inställningarna för kalendersynk för att lägga till uppgifter i den.",
  todo_calendar_connect: "Anslut",
  todo_calendar_removed: "Borttagen från din kalender",
  todo_calendar_added_later: "Tillagd. Din kalender kunde inte nås; Kjuup försöker igen senare.",
  todo_calendar_added: "Tillagd i din kalender",
  todo_calendar_no_date: "Bara en uppgift med datum kan läggas till i en kalender.",
  todo_calendar_failed: "Din kalender kunde inte uppdateras. Försök igen.",
  todo_calendar_date_title: "Inget datum ännu",
  todo_calendar_date_save: "Ange datum och lägg till",
  todo_calendar_date_body_web: "Den här markerade uppgiften har inget datum ännu. Ange ett för att lägga till den i din kalender.",
  kjuup_io_setup_saved: "Konfigurationen sparad",
  kjuup_io_setup_step: "Steg",
  kjuup_io_setup_chats_title: "Vill du använda chattar?",
  kjuup_io_setup_email_title: "Var vill du läsa din e-post?",
  kjuup_io_setup_chats_sub: "Chattar med kollegor och projektpartner är valfria. Du kan visa eller dölja dem i cockpit när som helst.",
  kjuup_io_setup_email_sub: "Det här avgör bara om du använder en e-postklient i Kjuup eller fortsätter med ditt nuvarande e-postprogram, till exempel Outlook eller något annat. Du kan byta senare.",
  kjuup_io_setup_chats_yes: "Ja, visa chattar",
  kjuup_io_setup_chats_yes_text: "Meddelanden innehåller chattar och e-post. Projekt har gruppchattar för alla inblandade.",
  kjuup_io_setup_chats_no: "Nej, arbeta utan chattar",
  kjuup_io_setup_chats_no_text: "Chattar är dolda. ”Meddelanden” blir ”E-post”; projekt, uppgifter och dagsrapporter finns kvar.",
  kjuup_io_setup_email_client: "E-postklient i Kjuup",
  kjuup_io_setup_email_client_text: "Läs och besvara e-post direkt i Kjuup.",
  kjuup_io_setup_email_reports: "Nuvarande e-postklient",
  kjuup_io_setup_email_reports_text: "Fortsätt läsa och svara i ditt nuvarande program, till exempel Outlook eller något annat.",
  kjuup_io_setup_skip: "Senare",
  next: "Nästa",
  kjuup_io_setup_finish: "Slutför konfigurationen",
  today_label: "idag",
  tomorrow_label: "imorgon",
  cockpit_todo_overdue: "försenad",
  cockpit_report_management_fazit: "Sammanfattning för ledningen",
  cockpit_todo_appointment: "Möte",
  cockpit_todo_deadline: "Tidsfrist",
  cockpit_todo_deadline_define: "Ange tidsfrist",
  pro_todo_status_acknowledged: "Bekräftad",
  pro_todo_responsible: "Ansvarig",
  pro_todo_notice_confirmed: "Bekräftad i chatten",
  pro_todo_notice_sent_at: "Meddelande skickat",
  pro_todo_notice_again: "Skicka meddelandet igen",
  pro_todo_notice_send: "Informera via Kjuup-meddelande",
  pro_todo_add_assignee: "Lägg till",
  pro_todo_edit: "Redigera",
  pro_todo_change_room: "Byt projekt",
  pro_todo_due_on: "Förfaller den",
  pro_todo_edit_due: "Redigera förfallodatum",
  pro_todo_no_date: "Inget datum",
  pro_todo_edit_description: "Redigera beskrivning",
  pro_todo_no_description: "Ingen beskrivning ännu",
  pro_todo_title_label: "Titel",
  pro_todo_title_placeholder: "Ange titel...",
  pro_todo_task: "Uppgift",
  pro_todo_what: "Vad behöver göras?",
  pro_todo_source_email: "E-post",
  pro_todo_sources: "Källor",
  previous: "Föregående",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (upp till {max} anställda)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (upp till {max} anställda)",
  kjuup_plus_abo_status_ends: "Upphör den {date}",
  kjuup_plus_abo_seats_over: "Fler än {max} anställda – Kjuup kontaktar dig med ett individuellt erbjudande.",
  kjuup_plus_abo_seats_next: "Om fler anställda tillkommer byter paketet automatiskt till {next} (proportionellt debiterat).",
  kjuup_plus_abo_seats_used: "{used} av {total} platser används",
  kjuup_plus_abo_seats_free: "{count} platser kvar",
  kjuup_plus_abo_intro_until: "till {date}",
  kjuup_plus_abo_invoice_open: "Öppen · förfaller {date}",
  kjuup_plus_abo_invoices_all: "Visa alla {count}",
  kjuup_plus_abo_requested_hint: "Uppsägning begärd den {date}. Kjuup bekräftar den vid periodens slut ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup granskar din begäran och bekräftar uppsägningen vid periodens slut ({end}). Fram till dess förblir Kjuup+ aktivt.",
  kjuup_plus_abo_withdrawn: "Begäran om uppsägning återkallad",
  kjuup_plus_abo_requested: "Uppsägning begärd",
  cockpit_upsell_plus_intro_hint: "första {months} månaderna, sedan {price}",
  cockpit_upsell_plus_badge: "INTROPRIS I {months} MÅNADER",
  calendar_syncing: "Uppdaterar från kalendern…",
  calendar_sync_up_to_date: "Kalendern är aktuell",
  calendar_sync_failed: "Synkroniseringen misslyckades",
  delete_multiple_tasks_confirm: "Är du säker på att du vill radera {count} ToDo:s?",
  todos_deleted_count: "{count} ToDo:s raderade",
  todos_deleted_partial: "{ok} ToDo:s raderade, {fail} misslyckades",
  todo_unknown: "Okänd",
  todo_created_from_message: "Uppgift skapad från det här meddelandet",
  kjuup_io_todo_calendar_trial_ended_note: "Kalendersynkronisering · Prenumerera",
  kjuup_io_todo_calendar_nudge: "Synka den här ToDo:n till din kalender?",
  kjuup_io_todo_calendar_nudge_cta: "Aktivera Kjuup.io",
  todo_confirmed: "ToDo bekräftad",
  pro_todo_bulk_delete_title: "Ta bort {{n}} uppgifter?",
  pro_todo_previous_none_own: "De försenade uppgifterna har tilldelats dig av andra och kan bara tas bort av dem.",
  pro_todo_previous_none: "Inga försenade uppgifter",
  pro_todo_previous_title: "Ta bort {{n}} försenade uppgifter?",
  pro_todo_previous_text: "Alla dina öppna uppgifter från tidigare dagar tas bort.",
  pro_todo_previous_skipped: "{{n}} som tilldelats av andra finns kvar.",
  unassign_task_confirm: "Vill du avbryta din tilldelning för denna uppgift?",
  unassign_label: "Avbryt",
  pro_todo_delete_title: "Ta bort uppgift",
  pro_todo_today: "Idag",
  pro_todo_yesterday: "Igår",
  pro_todo_since_yesterday: "Sedan igår",
  pro_todo_mark_open: "Markera som öppen",
  verify_completion: "Verifiera",
  new_label: "Ny",
  bookmarked_no_mylist: "Bokmärkta uppgifter kan inte läggas till i Min lista",
  delete_only_own: "Du kan bara ta bort uppgifter som du själv har skapat",
  todo_clear_all: "Rensa alla",
  pro_todo_of_completed: "{{done}} av {{total}} klara",
  pro_todo_pick_date: "Välj ett datum",
  pro_todo_show_day: "Visa dag",
  pro_todo_section_upcoming: "Kommande",
  pro_todo_section_done: "Klara",
  pro_todo_room_empty_today: "Inga uppgifter i dag i det här projektet",
  pro_todo_room_empty_day: "Inga uppgifter den här dagen i det här projektet",
  pro_todo_delete_previous: "Ta bort alla",
  pro_todo_empty_title: "Inget här",
  pro_todo_empty_hint: "Inga uppgifter matchar den här vyn.",
  pro_todo_selected: "{{n}} valda",
  delete_selected_count: "Radera ({count})",
  pro_todo_adjust_done: "Klar",
  pro_todo_deleting: "Tar bort...",
  pro_todo_reopen: "Öppna uppgiften igen",
  pro_todo_step_done: "Klar",
  move_back_in_progress: "Tillbaka till pågående",
  pro_todo_mark_not_started: "Markera som inte påbörjad",
  back_into_in_progress: "Tillbaka till pågående",
  pro_todo_mark_in_progress: "Markera som pågående",
  unassign_todo: "Avbryt tilldelning av ToDo",
  pro_todo_open_room: "Öppna projekt",
  pro_todo_new_task: "Ny uppgift",
  select_user_back_to_in_progress: "Välj användaren som ska flyttas tillbaka till Pågående",
  cockpit_email_accounts_n_many: "{{n}} konton anslutna",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup-kontakter",
  combined_tab_teams: "Teams-kontakter",
  combined_bridge_failed: "Teams-kopian kunde inte skapas.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup- och Teams-kontakter: en ny grupp skapas som även visas i Microsoft Teams.",
  teams_new_chat_title: "Ny Teams-chatt",
  teams_new_chat_topic: "Gruppnamn (valfritt)",
  teams_new_chat_start: "Starta chatt",
  teams_new_chat_creating: "Chatten skapas…",
  teams_new_chat_forbidden: "Microsoft Teams tillåter inte den här chatten (t.ex. en person utanför din organisation eller en policy från din IT).",
  teams_new_chat_too_many: "För många personer för en chatt.",
  teams_new_chat_type_hint: "Skriv ett namn för att söka i din organisation.",
  teams_new_chat_directory_forbidden: "Din organisation tillåter inte sökning i katalogen. Endast personer från dina Teams-chattar visas.",
  teams_new_chat_account: "Konto",
};
